import React__default from 'react';
import PropTypes from 'prop-types';
import { useBreakpoint } from '../../utils/use-breakpoint.js';
import { Spacer } from '../../Spacer/Spacer.js';
import { Container } from '../../Grid/Container.js';
import { Row } from '../../Grid/Row.js';
import { Col } from '../../Grid/Col.js';
import { Heading } from '../../Heading/Heading.js';

const ErrorPage = _ref => {
  let {
    content,
    heading,
    image
  } = _ref;
  const isMd = useBreakpoint('md');
  return /*#__PURE__*/React__default.createElement(Spacer, {
    marginTop: "layout-lg",
    marginBottom: "layout-xxl"
  }, /*#__PURE__*/React__default.createElement(Container, null, /*#__PURE__*/React__default.createElement(Row, {
    alignItems: "center"
  }, /*#__PURE__*/React__default.createElement(Col, {
    md: 5
  }, /*#__PURE__*/React__default.createElement(Row, null, /*#__PURE__*/React__default.createElement(Col, {
    xs: {
      offset: 3,
      size: 6
    },
    md: {
      offset: 2,
      size: 8
    },
    lg: {
      offset: 2,
      size: 10
    }
  }, image))), /*#__PURE__*/React__default.createElement(Col, {
    md: 7
  }, !isMd && /*#__PURE__*/React__default.createElement(Spacer, {
    marginBottom: "xl"
  }), /*#__PURE__*/React__default.createElement(Heading, {
    align: "center",
    level: 1,
    size: 2
  }, heading), content))));
};
ErrorPage.displayName = 'ErrorPage';
ErrorPage.propTypes = {
  content: PropTypes.node,
  heading: PropTypes.string.isRequired,
  image: PropTypes.node.isRequired
};

export { ErrorPage };
